import { render, staticRenderFns } from "./StudentSPIRHistory.vue?vue&type=template&id=27569ad9&scoped=true"
import script from "./StudentSPIRHistory.vue?vue&type=script&lang=ts"
export * from "./StudentSPIRHistory.vue?vue&type=script&lang=ts"
import style0 from "./StudentSPIRHistory.vue?vue&type=style&index=0&id=27569ad9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27569ad9",
  null
  
)

export default component.exports